import { RelativeCoordinate } from "@/shared/types";
import {
  ANNOTATION_TYPES,
  CAMERA_MODES,
  CAMERA_VIEW_MODES,
  CART_VIEWS,
  CUSTOMER_ACTIONS,
  EDITOR_MODES,
  ANNOTATION_ACTIONS,
  ANNOTATION_RECORD_STATUSES,
  HAND_IDS,
  HAND_SIDES,
  PREDICTION_TYPES,
  TIMELINE_EVENT_TYPES,
} from "./consts";

export type Journey = {
  id: string;
  status: AnnotationRecordStatus;
  note: string | null;
};

export type JourneyEvent = {
  type: typeof ANNOTATION_TYPES.JOURNEY;
  eventType: "enter" | "exit" | "order";
  id: string;
  zone: {
    id: string;
    description: string;
    projection: number[];
    polygon3d: number[];
  };
  orderId: string;
  pinCoordinates: RelativeCoordinate;
  cameraId: string;
  journeyId: string;
  notes: string | undefined;
  timestamp: Date; // Dash player date
};

export type Product = {
  name: string;
  imageUrl: string;
  barcode: string;
  skuId: number;
  variantId: string;
  count: number;
};

export type AnnotationData = {
  orderId: string;
  journeyId: string;
  timestamp: string;
  pinCoordinates: RelativeCoordinate;
  cameraId: string;
  calibrationId: number;
  gondolaName: string | null;
  gondolaId: number | null;
  planogramId: number;
  zoneId: string | null;
  proximityId?: string;
  handId?: HandId;
};

export type TimelineEvent = {
  id: string;
  type: TimelineEventType;
  timestamp: string;
  cameraId: string | null;
  gondolaName: string | null;
  journeyId: string | null;
};

export enum PlaybackState {
  Playing = "playing",
  Paused = "paused",
  Idle = "idle",
}

export type AnnotationRecordStatus =
  (typeof ANNOTATION_RECORD_STATUSES)[keyof typeof ANNOTATION_RECORD_STATUSES];

export type AnnotationView =
  (typeof ANNOTATION_TYPES)[keyof typeof ANNOTATION_TYPES];

export type EditorMode = (typeof EDITOR_MODES)[keyof typeof EDITOR_MODES];

export type CustomerAction =
  (typeof CUSTOMER_ACTIONS)[keyof typeof CUSTOMER_ACTIONS];

export type AnnotationAction =
  (typeof ANNOTATION_ACTIONS)[keyof typeof ANNOTATION_ACTIONS];

export type CartView = (typeof CART_VIEWS)[keyof typeof CART_VIEWS];

export type TimelineEventType =
  (typeof TIMELINE_EVENT_TYPES)[keyof typeof TIMELINE_EVENT_TYPES];

export type CameraMode = (typeof CAMERA_MODES)[keyof typeof CAMERA_MODES];

export type CameraViewMode =
  (typeof CAMERA_VIEW_MODES)[keyof typeof CAMERA_VIEW_MODES];

export type HandId = (typeof HAND_IDS)[keyof typeof HAND_IDS];
export type HandSide = (typeof HAND_SIDES)[keyof typeof HAND_SIDES];

export type PredictionType =
  (typeof PREDICTION_TYPES)[keyof typeof PREDICTION_TYPES];
